import React from 'react';
import { RouteObject } from 'react-router-dom';
import { maintenanceRoute, ratesIndexRoute, ratesRoute } from '@/root-app/app-routes/routes';
import RootApp from '@/root-app/RootApp';
import { ROUTE_NAMES } from '@/core/routes/routeNames';
import RoutingErrorPage from '@/components/Error/RoutingErrorPage';

const AtaRoutes: RouteObject = {
  path: ROUTE_NAMES.ROOT,
  Component: RootApp,
  errorElement: <RoutingErrorPage />,
  children: [ratesIndexRoute, ratesRoute, maintenanceRoute],
};

export default AtaRoutes;
